var __jsx = React.createElement;
import React, { useEffect } from "react";
import dynamic from "next/dynamic";
import { observer } from "mobx-react-lite";
import Head from "next/head";
import i18next from "i18next";
import { PageLayout } from "../../../util/constants";
import { useStore } from "@dp/state";
var JoinEclub = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.JoinEClub;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var JoinEclubPage = function JoinEclubPage(props) {
  var store = useStore();
  var urlParams = props.urlParams;
  useEffect(function () {
    var _store$initComponent;
    store === null || store === void 0 || (_store$initComponent = store.initComponent("Eclub")) === null || _store$initComponent === void 0 || _store$initComponent.then(function () {
      var _store$user;
      if ((urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("eclubsource")) === "app") {
        store.user.joinEclubModel.isFromAppPunchout = true;
      }
      store === null || store === void 0 || (_store$user = store.user) === null || _store$user === void 0 || _store$user.dispatchEclubStartEvent();
      // NOOP
    });
  }, []);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, i18next.t("title.joineclub.pagetitle", {
    defaultValue: "Join Eclub"
  }))), __jsx(JoinEclub, null));
};
JoinEclubPage.layout = PageLayout.NB_LAYOUT;
JoinEclubPage.layoutProps = {
  analyticsData: {
    pageName: "customer-service joineclub-step1",
    pageType: "customer-service"
  }
};
export default observer(JoinEclubPage);